/*
 *模糊搜索
 */
import { Input, message } from 'antd';
import React, { Component, Fragment } from 'react';
import '../../assets/style/itemStyle/searchAirport.scss';
import store from '../../redux/store';
import { getLocationAirport, getSearchPrompt } from '../../services/index';
import {
  airportSize,
  airportSort,
  customSort,
  debounce,
  getLocalStorage,
  getSessionStorage,
  getViewPortHeight,
  setSessionStorage,
} from '../../untils/auth';
import { popularCity } from '../../untils/popularCity';

export default class SearchAirport extends Component {
  constructor(props) {
    super(props);
    this.info = React.createRef();
    this.outerDiv = React.createRef();

    this.state = {
      list: {},
      showPlane: false,
      value: '', //搜索内容
      isShow: false, // 显示弹框
      airportAddress: this.props.dataValue.name, // 机场地址
      chooseValue: this.props.dataValue.name, // 选中值
      flyLocationFrom: {}, //机场，城市，州，国家
      flyLocationTo: {}, //机场，城市，州，国家
      inputType: '',
      showFromAirport: false,
      fromAirportList: [], //根据IP搜索周边机场
      fromCityList: [], //根据IP搜索周边城市
      showToAirport: false,
      toAirportList: [], //热门城市机场
      keyword: '', // 搜索关键词
      clickCount: 0,
      clearShow: false,
      notShow: false,
      placeholderShow: true,
      fromHover: false,
      toHover: false,
    };
    if (props.onRef) {
      //如果父组件传来该方法 则调用方法将子组件this指针传过去
      props.onRef(this);
    }
  }

  handleChange = (e, inputType) => {
    this.setState({
      value: e.target.value,
    });
    //更新出发地&目的地未填写校验
    this.props.updateInputRules(this.props.type);

    if (!e.target.value) {
      let { type } = this.props;
      this.props.getAddress(type, e.target.value);
    }

    this.setState({
      airportAddress: e.target.value,
      inputType,
    });
    this.debounceFunc(e.target.value);

    //出发地目的地改变清空包机列表
    if (this.props.page === 'charterQuote') {
      this.props.clearFlightsList([]);
    }
  };
  // 防抖
  debounceFunc = debounce((value) => {
    this.getList(value);
  }, 500);

  // 智能搜索
  getList = (value) => {
    if (value.split('').length) {
      this.setState({
        showFromAirport: false,
        showToAirport: false,
      });
      if (value.split('').length >= 3) {
        this.setState({
          showPlane: true,
        });
      } else {
        this.setState({
          showPlane: false,
          noData: true,
        });
      }

      //获取模糊搜索缓存数据
      let fuzzySearchData = store.getState().getFuzzySearchData;
      let keywordData = fuzzySearchData[value];
      if (keywordData) {
        if (Object.keys(keywordData).length > 0) {
          if (
            value.split('').length < 3 &&
            Object.keys(keywordData).length === 1 &&
            Object.keys(keywordData)[0] === 'airport'
          ) {
            this.setState({
              showPlane: false,
              list: {},
              noData: true,
            });
          } else {
            this.setState({
              list: keywordData,
              openCity: keywordData.cities,
              openAirport: keywordData.airports,
              isShow: true,
            });
          }
        } else {
          this.setState({
            list: {},
            noData: true,
          });
        }
      } else {
        let parmas = {
          key: value,
          searchType: 3,
        };
        getSearchPrompt(parmas).then((res) => {
          if (res.code) {
            this.setState({
              notShow: true,
            });
            let list = res.data;
            let openCity = list.cities;
            let openAirport = list.airports;
            if (openCity) {
              let dataType = ['precise', 'contain', 'correct', 'lenovo'];
              openCity = customSort({ data: openCity, sortBy: dataType, sortField: 'degree' });
              openCity.forEach((city) => {
                city.data.sort((a, b) => {
                  if (!a.hot) a.hot = 0;
                  if (!b.hot) b.hot = 0;
                  if (!a.population) a.population = 0;
                  if (!b.population) b.population = 0;
                  if (a.hot === b.hot) {
                    return b.population - a.population;
                  }
                  return b.hot - a.hot;
                });
              });

              // 二级机场排序
              // for (let airport of openCity) {
              //   for (let item of airport.data) {
              //     if (item.surroundAirport) {
              //       airportSize(item.surroundAirport);
              //       airportSort(item.surroundAirport);
              //     }
              //   }
              // }
            }
            // 机场大小 ['Large_Airport', 'Medium_Airport', 'Small_Airport'];
            if (openAirport) {
              // for (let airportlist of openAirport) {
              //   airportSize(airportlist.data);
              // }
              let dataType = ['precise', 'contain', 'correct', 'lenovo'];
              openAirport = customSort({
                data: openAirport,
                sortBy: dataType,
                sortField: 'degree',
              });
              // openAirport.forEach((city) => {
              //   airportSort(city.data);
              // });
            }
            if (Object.keys(res.data).length < 1) {
              this.setState({
                noData: true,
              });
            }
            if (
              value.split('').length < 3 &&
              Object.keys(res.data).length === 1 &&
              Object.keys(res.data)[0] === 'airport'
            ) {
              list = {};
              this.setState({
                showPlane: false,
                noData: true,
              });
            }

            this.setState({
              list,
              openCity,
              openAirport,
              isShow: true,
            });

            //模糊搜索数据缓存
            let searchData = store.getState().getFuzzySearchData;
            searchData.push((searchData[value] = list));
            store.dispatch({
              type: 'save_fuzzy_search',
              data: searchData,
            });
          }
        });
      }
    } else {
      this.setState({
        list: {},
        isShow: false,
        noData: false,
      });
    }
    this.setState({
      keyword: value,
    });
  };

  // 点击获取airport数据
  getAirportDetails = (e, index, item, type, idType) => {
    e.stopPropagation();
    let inputType = type;
    let end = document.getElementsByClassName('toinfo')[0].value;
    if (type === 'from' && !end) {
      document.getElementsByClassName('toinfo')[0].focus();
    }
    if (type === 'to') {
      this.props.getfocus('to');
    } else {
      this.props.getfocus('from');
    }
    this.saveFlyLocation(item, inputType, idType);

    return this.handleChoseData(e, item);
  };

  //为获取报价弹窗提供出发地和目的地的数据
  saveFlyLocation = (data, inputType, idType) => {
    if (inputType === 'from') {
      data.idType = idType;
      setSessionStorage('from', JSON.stringify(data));
    } else {
      data.idType = idType;
      setSessionStorage('to', JSON.stringify(data));
    }
  };
  // 关闭机场弹窗

  closePopup = (e) => {
    if (this.props.page === 'home') {
      if (
        this.outerDiv.current &&
        !this.outerDiv.current.contains(e.target) &&
        this.props.stickyNavRef.current &&
        !this.props.stickyNavRef.current.contains(e.target)
      ) {
        this.setState({
          isShow: false,
        });
      }
    } else {
      this.setState({
        isShow: false,
      });
    }

    if (!this.state.chooseValue) {
      this.setState({
        airportAddress: '',
      });
    }
  };
  // 获取缓存数据
  getCacheData = () => {
    let fromValue = !JSON.parse(getSessionStorage('from'))
      ? ''
      : JSON.parse(getSessionStorage('from')).name ||
      JSON.parse(getSessionStorage('from')).additional; //去程机场
    let toValue = !JSON.parse(getSessionStorage('to'))
      ? ''
      : JSON.parse(getSessionStorage('to')).name || JSON.parse(getSessionStorage('to')).additional; //去程机场

    this.setState({
      airportAddress: this.props.type === 'from' ? fromValue : toValue, //去程机场
      chooseValue: this.props.type === 'from' ? fromValue : toValue, //去程机场
    });
  };

  //出发地&目的地聚焦
  searchInputFocus = (type) => {
    this.props.updateInputFocus(type);
    let { fromAirportList, airportAddress } = this.state;
    this.setState({
      clearShow: true,
      placeholderShow: false,
    });

    //首页出发地目的地获取焦点时候滚动到合适位置
    if (this.props.page === 'home') {
      this.props.scrollUpHandle();
    }
    if (!airportAddress) {
      if (type === 'from') {
        if (fromAirportList.length < 1) {
          //根据IP搜索周边机场
          this.getInputFromAirport();
        } else {
          this.setState({
            fromAirportList,
            showFromAirport: true,
            isShow: true,
            noData: false,
            list: {},
          });
        }
      } else {
        //热门城市机场推荐
        this.getInputToAirport();
      }
    } else {
      this.getList(airportAddress);
    }
  };

  //点击IP搜索/获取热门推荐的机场
  airportClickHandle = (e, item, type, idType) => {
    let end = document.getElementsByClassName('toinfo')[0].value;
    if (type === 'from' && !end) {
      document.getElementsByClassName('toinfo')[0].focus();
    }
    if (type === 'to') {
      this.props.getfocus('to');
    }
    let inputType = this.props.type;
    this.saveFlyLocation(item, inputType, idType);
    this.handleChoseData(e, item);
    //清空包机列表数据
    if (this.props.page === 'charterQuote') {
      this.props.clearFlightsList([]);
    }
  };
  //点击出发地获取IP搜索的机场
  getInputFromAirport = () => {
    getLocationAirport().then((res) => {
      if (res.code && Object.keys(res.data).length > 0) {
        let cityList = res.data.cities[0].data;
        let list = res.data.cities[0].data[0].surroundAirport || [];
        // 机场热度排序 大小排序
        // airportSize(list);
        // airportSort(list);
        this.setState({
          fromCityList: cityList,
          fromAirportList: list,
          showFromAirport: true,
          isShow: true,
          noData: false,
          list: {},
        });
      } else {
        this.setState({
          fromAirportList: [],
          showFromAirport: false,
          isShow: false,
        });
      }
    });
  };

  //热门机场推荐
  getInputToAirport = () => {
    let { toAirportList } = this.state;
    for (let item of popularCity) {
      toAirportList.push(item);
    }
    this.setState({
      toAirportList,
      showToAirport: true,
      isShow: true,
      noData: false,
      list: {},
    });
  };

  //出发地目的地无内容时置灰处理
  searchInputBlur = (e) => {
    if (!this.state.chooseValue) {
      this.setState({
        airportAddress: '',
      });
    }
    if (this.props.page === 'home') {
      if (this.props.type === 'from') {
        this.props.priceQuoteInput(e.target.value, 0, 'startCity');
      } else {
        this.props.priceQuoteInput(e.target.value, 1, 'endCity');
      }
    }
    this.setState({
      clearShow: false,
      placeholderShow: true,
    });
  };
  // 处理所选出发地/目的地置灰样式
  handleChoseData = (e, item) => {
    e.stopPropagation();
    let data = item;
    let { type } = this.props;

    this.setState({
      airportAddress: data.name,
      chooseValue: data.name,
      isShow: false,
    });
    this.props.getAddress(type, data);

    if (this.props.page === 'home') {
      if (this.props.type === 'from') {
        this.props.priceQuoteInput(item.name, 0, 'startCity');
      } else {
        this.props.priceQuoteInput(item.name, 1, 'endCity');
      }
    }
  };
  // 清空value
  clearValue = () => {
    let { type } = this.props;
    this.setState({
      value: '',
      airportAddress: '',
      isShow: false,
      openAirport: [],
      openCity: [],
    });
    let val = this.state.value;
    this.props.getAddress(type, val);
    if (type === 'from') {
      this.getInputFromAirport();
    } else {
      this.getInputToAirport();
    }
  };

  onMouseEnter() {
    if (this.props.type === 'from') {
      this.setState({ fromHover: true });
    } else {
      this.setState({ toHover: true });
    }
  }

  onMouseLeave() {
    if (this.props.type === 'from') {
      this.setState({ fromHover: false });
    } else {
      this.setState({ toHover: false });
    }
  }

  componentDidMount() {
    // 获取缓存数据
    if (this.props.page !== 'home') {
      this.getCacheData();
    }
    document.querySelector('body').addEventListener('click', this.closePopup);

    if (this.props.defaultSearchKey) {
      this.setState({
        airportAddress: this.props.defaultSearchKey,
        chooseValue: this.props.defaultSearchKey,
        isShow: false,
      });
    }
  }
  // 卸载
  componentWillUnmount() {
    document.querySelector('body').removeEventListener('click', this.closePopup);
  }

  render() {
    let {
      showPlane,
      noData,
      isShow,
      airportAddress,
      showFromAirport,
      fromAirportList,
      fromCityList,
      showToAirport,
      toAirportList,
      clearShow,
      notShow,
      placeholderShow,
      openCity,
      openAirport,
      fromHover,
      toHover,
    } = this.state;
    return (
      <div
        className={`search-results ${this.props.resultSstyle === 'results-style' ? 'results-style' : null
          }`}
        onMouseEnter={() => this.onMouseEnter()}
        onMouseLeave={() => this.onMouseLeave()}
      >
        <div
          className={`search-airport ${this.props.page === 'home'
              ? this.props.type === 'from'
                ? this.props.inputClass[0]
                : this.props.inputClass[1]
              : ''
            }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* 出发点和目的地的icon */}
          {this.props.type === 'from' ? (
            <div
              className="icon-text"
              onClick={() => {
                this.info.current.focus();
              }}
            >
              <img
                src={`/imgs/svg/home/${fromHover ? 'from.svg' : 'from-grey.svg'}`}
                alt="departure icon"
              />
              {this.props.page !== 'home' && (
                <span className={`${this.props.inputRules.fromCity ? 'error' : ''}`}>
                  Departure
                </span>
              )}
            </div>
          ) : (
            <div
              className="icon-text"
              onClick={() => {
                this.info.current.focus();
              }}
            >
              <img
                src={`/imgs/svg/home/${toHover ? 'to.svg' : 'to-grey.svg'}`}
                alt="destination icon"
              />
              {this.props.page !== 'home' && (
                <span className={`${this.props.inputRules.toCity ? 'error' : ''}`}>
                  Destination{' '}
                </span>
              )}
            </div>
          )}
          {/* 搜索目的地 */}
          <div style={{ position: 'relative' }} ref={this.outerDiv}>
            <Input
              className={`${this.props.page === 'home'
                  ? this.props.type === 'from'
                    ? this.props.inputRules.fromCity
                      ? 'error'
                      : ''
                    : this.props.inputRules.toCity
                      ? 'error'
                      : ''
                  : ''
                } ${this.props.type === 'from' ? 'frominfo' : 'toinfo'}`}
              ref={this.info}
              placeholder={
                placeholderShow
                  ? this.props.type === 'to'
                    ? 'Where to?'
                    : 'Where from?'
                  : 'city, airport, icao, iata code'
              }
              onChange={(e) => {
                this.handleChange(e, this.props.type === 'from' ? 'from' : 'to');
              }}
              onBlur={(e) => {
                this.searchInputBlur(e);
              }}
              onFocus={() => {
                this.searchInputFocus(this.props.type);
              }}
              value={airportAddress}
            />
            {clearShow && (this.state.value || airportAddress) ? (
              <span
                className={this.props.clear ? 'clear-btn' : 'clear-btn2'}
                onMouseDown={() => {
                  this.clearValue();
                }}
              ></span>
            ) : (
              ''
            )}
          </div>
        </div>
        <div
          className={`list ${this.props.currentFocusInput} ${this.props.currentFocusInput === this.props.type && isShow ? 'isShow' : 'isNot'
            }`}
        >
          {/* 模糊搜索 */}
          <ul className={`rearch-results-list ${!openCity && !openAirport ? 'noData' : ''}`}>
            <div className="list-height">
              <div className="show-height">
                {/* 机场数据 */}
                <ul className="airport-list">
                  {showPlane &&
                    openAirport &&
                    openAirport.map((airport, index) => {
                      return airport.data.map((item, index) => {
                        return (
                          <li
                            className={`list-item-plane `}
                            key={index}
                            onClick={(e) =>
                              this.getAirportDetails(e, index, item, this.props.type, 'airport')
                            }
                          >
                            <div className="list-item airport">
                              <div>
                                <i className="bg-image plane"></i>
                                <span
                                  className="airport-name openAirport"
                                  style={{ textAlign: 'left' }}
                                >
                                  <span>{item.name}</span>
                                  <span>
                                    {item.cityNames}, {item.stateName}, {item.countryIso2}
                                  </span>
                                </span>
                              </div>
                              <span className="airport-iso">{item.icao}</span>
                            </div>
                          </li>
                        );
                      });
                    })}
                </ul>
                {/* city数据 */}
                {openCity &&
                  openCity.map((city, index) => {
                    return city.data.map((item, index) => {
                      return (
                        <li key={index} className={`city-one`}>
                          {/* 一级 */}
                          <div
                            className={`list-item list-item-first list-item-top`}
                            onClick={(e) =>
                              this.getAirportDetails(e, index, item, this.props.type, 'city')
                            }
                          >
                            {
                              <>
                                <div>
                                  <i className="bg-image"></i>
                                  <span className="state-country-name">
                                    <span>{item.name}</span>
                                    <span className="shorter-name">
                                      {item.stateName}, {item.countryIso2}
                                    </span>
                                  </span>
                                </div>
                                <span>
                                  <img
                                    src={`${process.env.REACT_APP_ASSET_URL
                                      }/country/${item.countryIso2.toLowerCase()}.webp`}
                                    alt="flag"
                                  />
                                </span>
                              </>
                            }
                          </div>
                          {this.state.value.split('').length > 2 && (
                            <ul className={`city-detail-two`}>
                              {item.surroundAirport &&
                                item.surroundAirport.map((items, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={(e) =>
                                        this.getAirportDetails(
                                          e,
                                          index,
                                          items,
                                          this.props.type,
                                          'airport'
                                        )
                                      }
                                    >
                                      <div className="list-item ">
                                        <div style={{ paddingLeft: '16px' }}>
                                          <i className="bg-image plane"></i>
                                          <span className="city-name">
                                            <div>{items.name}</div>
                                            <div>
                                              {JSON.parse(items.cityNames)}, {items.stateName},{' '}
                                              {items.countryIso2}
                                            </div>
                                          </span>
                                        </div>
                                        <span className="airport-iso">{items.icao}</span>
                                      </div>
                                    </li>
                                  );
                                })}
                            </ul>
                          )}
                        </li>
                      );
                    });
                  })}
                {!openCity && !openAirport && noData && notShow && (
                  <div className="noSearchData">
                    <img
                      src={require('../../assets/imgs/svg/warning.svg').default}
                      alt="warning icon"
                    />
                    <p>No relevant results were found</p>
                    <p className="tips">
                      Tips: Please enter the correct city name, <br />
                      airport name, <br />
                      icao or iata code and try again.
                    </p>
                  </div>
                )}

                {/* IP获取周边机场 */}
                {showFromAirport && fromAirportList && (
                  <>
                    <li className="airports-title surround-airports-title">
                      <div className="list-item" style={{ border: 'none' }}>
                        <h3>Recommended airport</h3>
                        <p>Airports displayed based on your location</p>
                      </div>
                    </li>
                    {fromCityList.map((item, index) => {
                      return (
                        <li
                          className="airports-title surround-location-city"
                          key={item.id}
                          onClick={(e) => {
                            this.airportClickHandle(e, item, 'from', 'city');
                          }}
                        >
                          <div className="list-item">
                            <img
                              src={require('../../assets/imgs/svg/position_icon.svg').default}
                              alt="position icon"
                            />
                            <span>{item.name}</span>
                          </div>
                        </li>
                      );
                    })}
                    {fromAirportList.map((item, index) => {
                      return (
                        <li
                          className="airports-list surround-airports-list"
                          key={item.id}
                          onClick={(e) => {
                            this.airportClickHandle(e, item, 'from', 'airport');
                          }}
                        >
                          <div className="list-item">
                            <div>
                              <i className="bg-image"></i>
                              <span className="airport-name">
                                <span>{item.name}</span>
                                <span>
                                  {JSON.parse(item.cityNames)}, {item.stateName}, {item.countryIso2}
                                </span>
                              </span>
                            </div>
                            <span className="flex-left">
                              <i>{item.icao}</i>
                            </span>
                          </div>
                        </li>
                      );
                    })}
                  </>
                )}

                {/* 热门机场推荐 */}
                {showToAirport && toAirportList && (
                  <>
                    <li className="airports-title hot-airports-title">
                      <div className="list-item" style={{ border: 'none' }}>
                        <h3 style={{ marginBottom: '8px' }}>Popular airports</h3>
                      </div>
                    </li>
                    {toAirportList.map((item, index) => {
                      return (
                        <li
                          className="airports-list hot-airports-list"
                          key={index}
                          onClick={(e) => {
                            this.airportClickHandle(e, item, 'to', 'airport');
                          }}
                        >
                          <div className="list-item">
                            <div>
                              {index < 3 ? (
                                <i className="bg-image hot-airport-icon"></i>
                              ) : (
                                <i className="bg-image"></i>
                              )}
                              <span className="state-country-name">
                                <span>{item.name}</span>
                                <span className="shorter-name">
                                  {item.cityNames}, {item.stateName}, {item.countryIso2}
                                </span>
                              </span>
                            </div>
                            <span className="flex-left">
                              <i>{item.icao}</i>
                            </span>
                          </div>
                        </li>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </ul>
        </div>
      </div>
    );
  }
}
